import React, { ReactNode, useContext } from "react";

import { Link, useParams } from "react-router-dom";

import { AdditionalOfferInteractionTypeEnum } from "@data-types/analytics-tracker/AdditionalOfferInteractionTypeEnum";
import { EventContext, LookupContext, OfferStoreContext } from "@gp/components";
import { AdditionalOfferViewStore } from "@state/stores/offer/shared/AdditionalOfferViewStore";
import { analyticsTracker } from "@utils/analytics";
import { buildRoute } from "@utils/common/buildOfferRoute";
import { DefaultPath } from "@utils/common/defaultRoutePathsEnum";
import { observer } from "mobx-react";

export function AdditionalOfferLinkWrapper({
	children,
}: {
	children: ReactNode;
}) {
	const store = useContext(OfferStoreContext);

	if (store instanceof AdditionalOfferViewStore) {
		return <AdditionalOfferLink>{children}</AdditionalOfferLink>;
	}

	return <>{children}</>;
}

const AdditionalOfferLink = observer(function AdditionalOfferLink({
	children,
}: {
	children: ReactNode;
}) {
	const event = useContext(EventContext);
	const { teams } = useContext(LookupContext);
	const params = useParams<{
		culture: string;
		period: string;
		segments: string;
	}>();

	// @ts-expect-error
	const sportAbrv = event.sport?.abrv;
	const homeTeamAbrv = teams.get(event.teamOneId || "")?.abrv || "";
	const awayTeamAbrv = teams.get(event.teamTwoId || "")?.abrv || "";

	const link = event.isLive
		? `/${params.culture}/${DefaultPath.LIVE}/${event.id}`
		: buildRoute.eventCanonical({
				culture: params.culture,
				period: params.period,
				eventIds: event.id,
				teamOneAbrv: homeTeamAbrv,
				teamTwoAbrv: awayTeamAbrv,
			});

	return (
		<Link
			to={link}
			onClick={() => {
				analyticsTracker.trackAdditionalOfferInteraction(
					event.isLive
						? AdditionalOfferInteractionTypeEnum.LiveAdditionalOffer
						: AdditionalOfferInteractionTypeEnum.PrematchAdditionalOffer,
					sportAbrv,
					homeTeamAbrv,
					awayTeamAbrv
				);
			}}
			className="event__link"
		>
			{children}
		</Link>
	);
});
